import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { supabase } from "@/lib/supabase";

export default function useIsAdmin(): boolean {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let active = true;

    function check(session: Session | null) {
      if (!session?.user) {
        if (active) setIsAdmin(false);
        return;
      }

      supabase
        .from("profiles")
        .select("is_admin")
        .eq("id", session.user.id)
        .maybeSingle()
        .then(({ data }) => {
          if (active) setIsAdmin(Boolean(data?.is_admin));
        })
        .catch(() => {
          if (active) setIsAdmin(false);
        });
    }

    supabase.auth.getSession().then(({ data }) => {
      if (active) check(data.session);
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      check(session);
    });

    return () => {
      active = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  return isAdmin;
}